export default "__VITE_ASSET__01605be6__"